// src/components/homepage/SolutionsSection.jsx
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const ChevronLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-15 h-15 md:w-20 md:h-20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5L8.25 12l7.5-7.5"
    />
  </svg>
);
const ChevronRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-15 h-15 md:w-20 md:h-20"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 4.5l7.5 7.5-7.5 7.5"
    />
  </svg>
);

const SolutionsSection = ({ title, solutions }) => {
  const swiperRef = useRef(null);

  if (!solutions || solutions.length === 0) {
    return null;
  }

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  return (
    <section className="py-10 md:py-14 bg-[#003366] text-white">
      {" "}
      <div className="container mx-auto">
        {title && (
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-center mb-8 md:mb-10 uppercase tracking-wider mx-auto xl:max-w-screen-lg 2xl:max-w-screen-2xl">
            <span className="underline underline-offset-8 decoration-3 decoration-white">
              {title}
            </span>
          </h2>
        )}

        <div className="relative flex items-center">
          {" "}
          <button
            onClick={goPrev}
            className="solution-swiper-button-prev p-1 mr-4 md:mr-8 text-white opacity-80 hover:opacity-100 disabled:opacity-30 disabled:cursor-not-allowed transition-opacity"
          >
            <ChevronLeftIcon />
          </button>
          <Swiper
            ref={swiperRef}
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={1.2}
            centeredSlides={false}
            loop={false}
            navigation={{
              nextEl: ".solution-swiper-button-next",
              prevEl: ".solution-swiper-button-prev",
              disabledClass: "swiper-button-disabled-custom-sol",
            }}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              1250: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
            className="flex-grow overflow-hidden"
          >
            {solutions.map((solution) => (
              <SwiperSlide
                key={solution.id}
                className="h-auto self-stretch flex"
              >
                {" "}
                {solution.url ? (
                  <Link
                    to={solution.url}
                    className="flex items-center text-left p-2 md:p-3 h-full"
                  >
                    {" "}
                    <div className="flex-shrink-0 w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 mr-3 md:mr-4 p-1 shadow-sm flex items-center justify-center">
                      {solution.logo && solution.logo.url ? (
                        <img
                          src={`${solution.logo.url}`}
                          alt={solution.logo.alternativeText || solution.title}
                          className="object-contain"
                        />
                      ) : (
                        <div className="w-full h-full bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-500">
                          N/A
                        </div>
                      )}
                    </div>
                    <div className="flex-grow">
                      <h3 className="text-xl sm:text-2xl md:text-3xl leading-tight">
                        {solution.title}
                      </h3>
                    </div>
                  </Link>
                ) : (
                  <div className="flex items-center text-left p-2 md:p-3 h-full">
                    {" "}
                    <div className="flex-shrink-0 w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 mr-3 md:mr-4 p-1 shadow-sm flex items-center justify-center">
                      {solution.logo && solution.logo.url ? (
                        <img
                          src={`${solution.logo.url}`}
                          alt={solution.logo.alternativeText || solution.title}
                          className="object-contain"
                        />
                      ) : (
                        <div className="w-full h-full bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-500">
                          N/A
                        </div>
                      )}
                    </div>
                    <div className="flex-grow">
                      <h3 className="text-xl sm:text-2xl md:text-3xl leading-tight">
                        {solution.title}
                      </h3>
                    </div>
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
          <button
            onClick={goNext}
            className="solution-swiper-button-next p-1 ml-4 md:ml-8 text-white opacity-80 hover:opacity-100 disabled:opacity-30 disabled:cursor-not-allowed transition-opacity"
          >
            <ChevronRightIcon />
          </button>
        </div>
      </div>
      <style jsx global>{`
        .swiper-button-disabled-custom-sol {
          opacity: 0.3 !important;
          cursor: not-allowed !important;
          pointer-events: none;
        }
      `}</style>
    </section>
  );
};

export default SolutionsSection;
